
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

$parcel$export(module.exports, "showEntri", () => $882b6d93070905b3$export$5db49c2b1f5f3d15);
$parcel$export(module.exports, "checkDomain", () => $882b6d93070905b3$export$c0fc9c4c5cb513a);
$parcel$export(module.exports, "purchaseDomain", () => $882b6d93070905b3$export$6f6a60b4e6797e88);
$parcel$export(module.exports, "close", () => $882b6d93070905b3$export$8360e631d277ea4d);
function $882b6d93070905b3$var$initializeEntri() {
    return new Promise((resolve, reject)=>{
        const entriWindow = window.entri;
        if (entriWindow) {
            resolve(entriWindow);
            return;
        }
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "https://cdn.goentri.com/entri.js";
        script.addEventListener("load", ()=>{
            resolve(window.entri);
        });
        script.addEventListener("error", ()=>{
            reject(new Error("Failed to load the Entri SDK."));
        });
        document.body.appendChild(script);
    });
}
const $882b6d93070905b3$export$5db49c2b1f5f3d15 = async (config)=>{
    const entri = await $882b6d93070905b3$var$initializeEntri();
    return entri.showEntri(config);
};
const $882b6d93070905b3$export$c0fc9c4c5cb513a = async (domain, config)=>{
    const entri = await $882b6d93070905b3$var$initializeEntri();
    return entri.checkDomain(domain, config);
};
const $882b6d93070905b3$export$6f6a60b4e6797e88 = async (config)=>{
    const entri = await $882b6d93070905b3$var$initializeEntri();
    return entri.purchaseDomain(config);
};
const $882b6d93070905b3$export$8360e631d277ea4d = async ()=>{
    const entri = await $882b6d93070905b3$var$initializeEntri();
    return entri.close();
};


//# sourceMappingURL=main.js.map
